import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add_row_after",
  "use": "add_row_after-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add_row_after\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 6a1 1 0 00-1-1h-4V1a1 1 0 10-2 0v4H7a1 1 0 100 2h4v4a1 1 0 102 0V7h4a1 1 0 001-1zM23 24a1 1 0 001-1v-8a1 1 0 00-1-1H1a1 1 0 00-1 1v8a1 1 0 001 1h22zm-2-2a1 1 0 001-1v-4a1 1 0 00-1-1H3a1 1 0 00-1 1v4a1 1 0 001 1h18z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol